function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { getDarkThemeFn, getLightThemeFn } from "../../utils/tokens";
import { useReducer } from "react";
import { defaultBreakpoints } from "../Breakpoints/BreakpointsProvider";
export var ACTIONS = {
    SET_BREAKPOINTS: 'SET_BREAKPOINTS',
    SET_COLOR_SCHEME: 'SET_COLOR_SCHEME',
    SET_DIRECTION: 'SET_DIRECTION',
    SET_FLAG: 'SET_FLAG',
    SET_FLAGS: 'SET_FLAGS',
    SET_PREFERS_REDUCED_MOTION: 'SET_PREFERS_REDUCED_MOTION'
};
export var defaultState = {
    breakpoints: defaultBreakpoints,
    colorScheme: 'light',
    depth: 0,
    direction: 'ltr',
    flags: {},
    prefersReducedMotion: false,
    themeFunctions: {
        light: getLightThemeFn,
        dark: getDarkThemeFn
    },
    themes: undefined,
    theme: undefined
};
var buildThemes = function(param1) {
    var flags = param1.flags, themeFunctions = param1.themeFunctions, themes = param1.themes;
    return Object.entries(themeFunctions).reduce(function(acc, param) {
        var _param = _slicedToArray(param, 2), key = _param[0], fn = _param[1];
        return _objectSpread({}, acc, _defineProperty({}, key, fn({
            flags: flags
        })));
    }, themes);
};
var getInitialState = function(initialState) {
    var ref11, ref1, ref2, ref3, ref4, ref5, ref6;
    var _themes, _flags;
    var flags = Object.keys((_themes = initialState.themes) !== null && _themes !== void 0 ? _themes : {}).length > 0 ? defaultState.flags : _objectSpread({}, defaultState.flags, (_flags = initialState.flags) !== null && _flags !== void 0 ? _flags : (ref11 = initialState.parent) === null || ref11 === void 0 ? void 0 : ref11.flags);
    var _themes1, _themeFunctions;
    var themeFunctions = _objectSpread({}, Object.keys((_themes1 = initialState.themes) !== null && _themes1 !== void 0 ? _themes1 : {}).reduce(function(acc, theme) {
        return _objectSpread({}, acc, _defineProperty({}, theme, function() {
            var ref;
            return (ref = initialState.themes) === null || ref === void 0 ? void 0 : ref[theme];
        }));
    }, defaultState.themeFunctions), (_themeFunctions = initialState.themeFunctions) !== null && _themeFunctions !== void 0 ? _themeFunctions : (ref1 = initialState.parent) === null || ref1 === void 0 ? void 0 : ref1.themeFunctions);
    var themes = buildThemes({
        themes: initialState.themes,
        themeFunctions: themeFunctions,
        flags: flags
    });
    var _colorScheme, ref7;
    var colorScheme = (ref7 = (_colorScheme = initialState.colorScheme) !== null && _colorScheme !== void 0 ? _colorScheme : (ref2 = initialState.parent) === null || ref2 === void 0 ? void 0 : ref2.colorScheme) !== null && ref7 !== void 0 ? ref7 : defaultState.colorScheme;
    var _breakpoints, ref8, _direction, ref9, _prefersReducedMotion, ref10;
    return {
        breakpoints: _objectSpread({}, defaultState.breakpoints, (_breakpoints = initialState.breakpoints) !== null && _breakpoints !== void 0 ? _breakpoints : (ref3 = initialState.parent) === null || ref3 === void 0 ? void 0 : ref3.breakpoints),
        colorScheme: colorScheme,
        depth: ((ref8 = (ref4 = initialState.parent) === null || ref4 === void 0 ? void 0 : ref4.depth) !== null && ref8 !== void 0 ? ref8 : defaultState.depth) + 1,
        direction: (ref9 = (_direction = initialState.direction) !== null && _direction !== void 0 ? _direction : (ref5 = initialState.parent) === null || ref5 === void 0 ? void 0 : ref5.direction) !== null && ref9 !== void 0 ? ref9 : defaultState.direction,
        flags: flags,
        prefersReducedMotion: (ref10 = (_prefersReducedMotion = initialState.prefersReducedMotion) !== null && _prefersReducedMotion !== void 0 ? _prefersReducedMotion : (ref6 = initialState.parent) === null || ref6 === void 0 ? void 0 : ref6.prefersReducedMotion) !== null && ref10 !== void 0 ? ref10 : defaultState.prefersReducedMotion,
        theme: themes[colorScheme],
        themeFunctions: themeFunctions,
        themes: themes
    };
};
var reducer = function(state, action) {
    var themes;
    switch(action.type){
        case ACTIONS.SET_BREAKPOINTS:
            return _objectSpread({}, state, {
                breakpoints: action.breakpoints
            });
        case ACTIONS.SET_COLOR_SCHEME:
            if (state.colorScheme === action.colorScheme) {
                return state;
            }
            if (state.themes[action.colorScheme]) {
                return _objectSpread({}, state, {
                    colorScheme: action.colorScheme,
                    theme: state.themes[action.colorScheme]
                });
            }
            throw Error("Theme ".concat(action.colorScheme, " not found"));
        case ACTIONS.SET_DIRECTION:
            if (state.direction === action.direction) {
                return state;
            }
            return _objectSpread({}, state, {
                direction: action.direction
            });
        case ACTIONS.SET_FLAG:
            if (state.flags[action.flag] === action.value) {
                return state;
            }
            themes = buildThemes({
                flags: _objectSpread({}, state.flags, _defineProperty({}, action.flag, action.value)),
                themeFunctions: state.themeFunctions,
                themes: state.themes
            });
            return _objectSpread({}, state, {
                flags: _objectSpread({}, state.flags, _defineProperty({}, action.flag, action.value)),
                theme: themes[state.colorScheme],
                themes: themes
            });
        case ACTIONS.SET_FLAGS:
            themes = buildThemes({
                flags: action.flags,
                themeFunctions: state.themeFunctions,
                themes: state.themes
            });
            return _objectSpread({}, state, {
                flags: action.flags,
                theme: themes[state.colorScheme],
                themes: themes
            });
        case ACTIONS.SET_PREFERS_REDUCED_MOTION:
            if (state.prefersReducedMotion === action.prefersReducedMotion) {
                return state;
            }
            return _objectSpread({}, state, {
                prefersReducedMotion: action.prefersReducedMotion
            });
        default:
            return state;
    }
};
export var useCarinaReducer = function(initialState) {
    return useReducer(reducer, initialState, getInitialState);
};
export var getCarinaActions = function(dispatch) {
    var setBreakpoints = function(breakpoints) {
        return dispatch({
            type: ACTIONS.SET_BREAKPOINTS,
            breakpoints: breakpoints
        });
    };
    var setColorScheme = function(colorScheme) {
        return dispatch({
            type: ACTIONS.SET_COLOR_SCHEME,
            colorScheme: colorScheme
        });
    };
    var setDirection = function(direction) {
        return dispatch({
            type: ACTIONS.SET_DIRECTION,
            direction: direction
        });
    };
    var setFlag = function(flag, value) {
        return dispatch({
            type: ACTIONS.SET_FLAG,
            flag: flag,
            value: value
        });
    };
    var setFlags = function(flags) {
        return dispatch({
            type: ACTIONS.SET_FLAGS,
            flags: flags
        });
    };
    var setPrefersReducedMotion = function(prefersReducedMotion) {
        return dispatch({
            type: ACTIONS.SET_PREFERS_REDUCED_MOTION,
            prefersReducedMotion: prefersReducedMotion
        });
    };
    return {
        setBreakpoints: setBreakpoints,
        setColorScheme: setColorScheme,
        setDirection: setDirection,
        setFlag: setFlag,
        setFlags: setFlags,
        setPrefersReducedMotion: setPrefersReducedMotion
    };
};
export default useCarinaReducer;
